// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_CLIENT = '/client';
const ROOTS_MANAGEMENT = '/management'
const ROOTS_ADMIN = '/admin'
// ----------------------------------------------------------------------
export const PATH_MANAGEMENT = {
  root: ROOTS_MANAGEMENT,
  general: {
    cadence: path(ROOTS_MANAGEMENT, ''),
    lead_search: path(ROOTS_MANAGEMENT, '/lead-search'),
    lead_details: path(ROOTS_MANAGEMENT, '/lead-details/:lead_id'),
    endpoints: path(ROOTS_MANAGEMENT, '/endpoints'),
    management_cadence_detail: path(ROOTS_MANAGEMENT, '/cadence/detail/:client_integrated_id/:cadence_id'),
    management_lead_detail: path(ROOTS_MANAGEMENT, '/lead/detail/:client_integrated_id/:cadence_id/:lead_id'),
    management_schedule_view: path(ROOTS_MANAGEMENT, '/endpoints/schedule/:endpoint_id'),
    management_pending_lead_view: path(ROOTS_MANAGEMENT, '/endpoints/pending-leads/:endpoint_id')
  }
};

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  teams: {
    teams: path(ROOTS_ADMIN, '/teams'),
  },
  users: {
    users: path(ROOTS_ADMIN, '/users'),
  },
  settings: {
    settings: path(ROOTS_ADMIN, '/settings'),
  },
  data_redaction: {
    data_redaction: path(ROOTS_ADMIN, '/data_redaction'),
    create: path(ROOTS_ADMIN, '/data_redaction/create/:data_redaction_id'),
    edit: path(ROOTS_ADMIN, '/data_redaction/edit/:data_redaction_id'),
    view: path(ROOTS_ADMIN, '/data_redaction/view/:data_redaction_id')
  }
};

export const PATH_CLIENT = {
  root: ROOTS_CLIENT,
  integration: {
    client: path(ROOTS_CLIENT, ''),
    list        : path(ROOTS_CLIENT, '/subaccount/list/:id'),
    list_root   : path(ROOTS_CLIENT, '/subaccount/list/'),
    detail      : path(ROOTS_CLIENT, '/subaccount/:detail/:id'),
    detail_root : path(ROOTS_CLIENT, '/subaccount/detail/'),
    map_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/endpointMapping'),
    cpi_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/cpiMapping'),
    said_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/saidMapping'),
    callcadence_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/callCadenceMapping'),
    duplicate_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/duplicatedChecksMapping'),
    override_detail_point: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/overrideMapping'),
    endpontSetting: path(ROOTS_CLIENT, '/endpoint-detail/:client_id/:endpoint_id/endpointSetting'),
    accounts: path(ROOTS_CLIENT, '/accounts'),
    create: path(ROOTS_CLIENT, '/create'),
    cadence_detail: path(ROOTS_CLIENT, '/cadence/detail/:client_integrated_id/:cadence_id'),
  }
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  guestSignin: path(ROOTS_AUTH, '/guests-signin'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password/:token'),
  updatePassword: path(ROOTS_AUTH, '/update-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  page404: '/404',
  page500: '/500'
};

export const PATH_HOME = {
  dashboard: ROOTS_DASHBOARD
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    create: path(ROOTS_DASHBOARD, '/create'),
    accounts: path(ROOTS_DASHBOARD, '/accounts'),
    cadence: path(ROOTS_DASHBOARD, '/cadence'),
    detail: path(ROOTS_DASHBOARD, '/detail/:id'),
    map: path(ROOTS_DASHBOARD, '/map/:client_id/:endpoint_id'),
    map_detail: path(ROOTS_DASHBOARD, '/endpoint-detail/:client_id/:endpoint_id?'),
    cadence_detail: path(ROOTS_DASHBOARD, '/cadence/detail/:client_integrated_id/:cadence_id'),
    versions: path(ROOTS_DASHBOARD, '/versions/:client_id/:endpoint_id'),
    cp_map: path(ROOTS_DASHBOARD, '/cp-map/:client_id/:endpoint_id'),
    said_map: path(ROOTS_DASHBOARD, '/said-map/:client_id/:endpoint_id'),
    new_version: path(ROOTS_DASHBOARD, '/version/create/:client_id/:endpoint_id'),
    edit_version: path(ROOTS_DASHBOARD, '/version/edit/:client_id/:endpoint_id'),
    client_exceptions: path(ROOTS_DASHBOARD, '/client_exceptions/:client_id'),
    call_cadence_map: path(ROOTS_DASHBOARD, '/call-cadence-map/:client_id/:endpoint_id'),
    duplicate_checks: path(ROOTS_DASHBOARD, '/duplicate-checks/:client_id/:endpoint_id'),
    overrides: path(ROOTS_DASHBOARD, '/overrides/:client_id/:endpoint_id'),
    csv: path(ROOTS_DASHBOARD, '/csv/:id/:client_uuid'),
  }
};
